export { UsMapModule } from './us-map.module';
export { UsMapComponent } from './us-map.component';
//# sourceMappingURL=index.js.map